import styled from 'styled-components';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PreferencesLayout = styled.section`
  width: 100%;
  min-width: 0;
  max-width: 1120px;
  margin: 0 auto;
  padding: 16px 20px;

  h1 { margin: 0 0 14px; font-size: 1.8rem; }
`;

const PreferencesTabs = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--line);
  padding-bottom: 10px;

  a {
    padding: 10px 14px;
    color: var(--text);
    text-decoration: none;
    border-bottom: 3px solid transparent;
  }

  a[aria-current='page'] {
    border-color: var(--accent);
    font-weight: 700;
  }
`;

function PreferencesPage() {
  const { can } = useAuth();

  return (
    <PreferencesLayout>
      <h1>Preferences</h1>
      <PreferencesTabs aria-label="Preferences sections">
        {can('bands:read') ? <NavLink to="bands">Bands</NavLink> : null}
        {can('app:access') ? <NavLink to="account">Account</NavLink> : null}
        {can('users:manage') ? <NavLink to="users">Users</NavLink> : null}
      </PreferencesTabs>
      <Outlet />
    </PreferencesLayout>
  );
}

export default PreferencesPage;
